import { render, staticRenderFns } from "./AutoScoringToggle.vue?vue&type=template&id=20a259f0"
import script from "./AutoScoringToggle.vue?vue&type=script&lang=js"
export * from "./AutoScoringToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports